import {Injectable} from '@angular/core';
import {ApiService} from '@common-lib';
import {map} from 'rxjs/operators';

@Injectable()
export class ProductSettingsService {

  constructor(private api: ApiService) {
  }

  getList() {
    return this.api.get('/admin/product-settings').pipe(map(({result}) => result));
  }

  update(productId: number, key: string, value: string, locale: string) {
    return this.api.post('/admin/product-settings', {
      productId,
      key,
      value,
      locale
    }).pipe(map(({result}) => result));
  }

  delete(productSetting) {
    if (productSetting) {
      return this.api.delete('/admin/product-settings/' + productSetting.id).pipe(map(response => response));
    }
  }
  transfer(productId: number, id: number, locale: string) {
      return this.api.post('/admin/product-settings-transfer', {
        productId,
        id,
        locale
    }).pipe(map(response => response));
  }
  uploadImport(product, file) {
    return this.api.post('/admin/import-product-settings', {productId: product, settings: file}).pipe(map(response => response));
  }
}



// WEBPACK FOOTER //
// ./src/app/pages-services/product-settings.service.ts